



<body>
<div style="text-align: center;padding-top: 40px;">
    <h1 style="font-weight: bold;" *ngIf="mensajeEmail">Hemos enviado el contrato a su email</h1>
</div>

</body>